export default [
  {
    key: 'name',
    label: 'Nama Lengkap',
    type: 'text',
    required: true,
    maxLength: 255,
  },
  {
    key: 'username',
    label: 'Username',
    type: 'text',
    required: true,
    maxLength: 255,
    regex: /^[A-Za-z0-9_-]+$/,
  },
  {
    key: 'email',
    label: 'Email',
    type: 'email',
    required: true,
    maxLength: 255,
  },
  {
    key: 'phone',
    label: 'Nomor HP',
    type: 'phone',
    required: true,
    maxLength: 30,
  },
  {
    key: 'email_verified',
    label: 'Email Terverifikasi',
    type: 'radio',
    required: true,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
  },
  {
    key: 'phone_verified',
    label: 'Nomor HP Terverifikasi',
    type: 'radio',
    required: true,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
  },
]
